/* ============================================================
   KaNi Candy - Zurueck nach oben
   ============================================================ */
(function () {
  'use strict';

  var knopf = document.getElementById('kani-hoch');
  if (!knopf) return;

  var SCHWELLE = 600;
  var sichtbar = false;

  function pruefen() {
    /* In der Sortenwahl von Pick & Mix schon nach kurzem Scrollen: dort will
       man aus der langen Liste schnell zurueck zu Schritten und Filtern. */
    var schwelle = document.documentElement.classList.contains('kani-sorten-schritt') ? 250 : SCHWELLE;
    var soll = window.scrollY > schwelle;
    if (soll === sichtbar) return;
    sichtbar = soll;
    knopf.hidden = !soll;
    /* hidden alleine reicht nicht, weil die Einblendung animiert ist */
    if (soll) {
      /* setTimeout statt requestAnimationFrame: rAF ruht in inaktiven Tabs. */
      setTimeout(function () { knopf.classList.add('is-da'); }, 20);
    } else {
      knopf.classList.remove('is-da');
    }
  }

  knopf.addEventListener('click', function () {
    var sanft = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: sanft ? 'smooth' : 'instant' });
    /* Sanftes Scrollen ist nicht ueberall verfuegbar - etwa wenn der Browser
       Animationen drosselt. Bewegt sich nach kurzer Zeit nichts, hart springen,
       damit der Knopf niemals wirkungslos bleibt. */
    if (!sanft) return;
    var start = window.scrollY;
    setTimeout(function () {
      if (window.scrollY >= start - 4 && window.scrollY > 0) {
        window.scrollTo({ top: 0, behavior: 'instant' });
      }
    }, 500);
  });

  window.addEventListener('scroll', pruefen, { passive: true });
  document.addEventListener('kani:pruefen', pruefen);
  window.addEventListener('resize', pruefen, { passive: true });
  pruefen();
})();
